import { Box, Card, Skeleton, Stack } from '@mui/material';
import { Grid, GridBody, GridCell, GridHead, GridRow, randomInt } from '@schooly/style';
import { FC } from 'react';

const SKELETON_HEADER_ITEMS_COUNT = 3;
const SKELETON_ROW_ITEMS_COUNT = 6;
const SKELETON_TABLE_COLUMNS_COUNT = 5;

const SkeletonPeriodRow: FC = () => (
  <GridRow withoutDefaultHover>
    <GridCell borderBottom={false} py={0.5}>
      <Skeleton variant="rectangular" width="100%" height={22} />
    </GridCell>
    <GridCell borderBottom={false} py={0.5}>
      <Skeleton variant="rectangular" width={`${randomInt(50, 100)}%`} height={22} />
    </GridCell>
    {Array.from({ length: SKELETON_TABLE_COLUMNS_COUNT }).map((_, i) => (
      <GridCell key={i} borderBottom={false} p={0.25} height={30}>
        <Skeleton variant="rectangular" height={26} />
      </GridCell>
    ))}
  </GridRow>
);

const SchoolTimetableStructuresCardSkeleton: FC = () => {
  return (
    <Card>
      <Stack
        direction="row"
        gap={1}
        p={2.5}
        sx={(theme) => ({ borderBottom: theme.mixins.borderValue() })}
      >
        {Array.from({ length: SKELETON_HEADER_ITEMS_COUNT }).map((_, index) => (
          <Stack key={index} gap={0.25} width={200}>
            <Skeleton variant="rectangular" width={70} height={18} />
            <Skeleton variant="rectangular" width={`${randomInt(50, 100)}%`} height={28} />
          </Stack>
        ))}
      </Stack>
      <Box p={2.5}>
        <Grid>
          <GridHead sx={{ '&.MuiTableHead-root .MuiTableCell-root': { height: 30, p: 0.5 } }}>
            <GridRow>
              <GridCell sx={{ width: 135, minWidth: 135 }} />
              <GridCell sx={{ minWidth: 100 }} />
              {Array.from({ length: SKELETON_TABLE_COLUMNS_COUNT }).map((_, index) => (
                <GridCell
                  key={index}
                  sx={{ width: `calc(60% / ${SKELETON_TABLE_COLUMNS_COUNT})`, minWidth: 50 }}
                >
                  <Stack alignItems="center">
                    <Skeleton variant="rectangular" width={30} height={18} />
                  </Stack>
                </GridCell>
              ))}
            </GridRow>
          </GridHead>

          <GridBody>
            {Array.from({ length: SKELETON_ROW_ITEMS_COUNT }).map((_, index) => (
              <SkeletonPeriodRow key={index} />
            ))}
          </GridBody>
        </Grid>
      </Box>
    </Card>
  );
};

const SKELETON_CARDS_COUNT = 2;

export const SchoolTimetableStructuresSkeleton: FC = () => {
  return (
    <Stack gap={2.5}>
      {Array.from({ length: SKELETON_CARDS_COUNT }).map((_, index) => (
        <SchoolTimetableStructuresCardSkeleton key={index} />
      ))}
    </Stack>
  );
};
